<img
    *ngIf="preserveColors; else monochromeIcon"
    class="core-ui-icon__image"
    [src]="iconPath"
    alt=""
    aria-hidden="true"
/>

<ng-template #monochromeIcon>
    <span
        class="core-ui-icon__mask"
        [style.webkitMaskImage]="'url(' + iconPath + ')'"
        [style.maskImage]="'url(' + iconPath + ')'"
    ></span>
</ng-template>
